import { ProductionOrderListPage } from "@/features/production/pages/ProductionOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/production/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["production.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductionOrderListPage,
});
